export default __webpack_public_path__ + "static/media/unitplaceholder.bd243018.png";